import { Dashboard, Requests } from '@/components';

export const RequestsPage = () => (
  <Dashboard isSearch openLogIn>
    <Requests />
  </Dashboard>
);
